export default __webpack_public_path__ + "2af5aa9658ae6ec9f7e15406f7cb8274.svg";